import { ProceedingMessage as ProceedingMessageResponse } from "../../api/HomePageResponseTypes";
import { Classifier } from "../../util/classifierManager";
import { DateString } from "../../util/conversionUtils";

export interface ProceedingMessage
  extends Omit<
    ProceedingMessageResponse,
    "menetluseLiik" | "menetluseAlamliik" | "seisund" | "teateLiik" | "saadetud" | "tahtaeg" | "vastatud"
  > {
  menetluseLiik: Classifier;
  menetluseAlamliik: Classifier;
  seisund: Classifier;
  teateLiik: Classifier;
  saadetud: DateString;
  tahtaeg: DateString;
  vastatud: DateString;
}

export enum ColumnHeader {
  proceedingNr = "proceedingNr",
  proceedingType = "proceedingType",
  proceedingSubtype = "proceedingSubtype",
  state = "state",
  messageType = "messageType",
  sender = "sender",
  sent = "sent",
  messageContent = "messageContent",
  receiver = "receiver",
  due = "due",
  response = "response",
  responded = "responded",
}

export const ColumnNameMap = new Map<ColumnHeader, keyof ProceedingMessage>([
  [ColumnHeader.proceedingType, "menetluseLiik"],
  [ColumnHeader.state, "seisund"],
  [ColumnHeader.messageType, "teateLiik"],
]);
